export default __webpack_public_path__ + "static/media/hyper-custom-desktop.bee624ba.png";